module.exports = __webpack_public_path__ + "img/Moldova.8fc4ea03.svg";